import React from "react";
import PanelGroupController from "../../../components/PanelGroupController";
import {fromJS} from "immutable";
import PropertiesList from "../../../components/panels/PropertiesList";
import Loading from "../../../components/Loading";
import GraphQLErrors from "../../../components/GraphQLErrors";
import {Query} from "react-apollo";
import {GET_PRODUCT} from "../../../queries/inventory";
import ProductImage from "../views/ProductImage";

const CustomerPropertiesPanel = (props) => {
  let elements = null;
  if (!props.productId) {
    elements = <p className="u-no-selection">Nothing selected</p>
  } else {
    let variables = {sku: props.productId}
    elements = (
      <Query query={GET_PRODUCT} variables={variables} skip={!props.productId}>
        {({ loading, error, data }) => {
          if (loading) return <Loading />
          if (error) return <GraphQLErrors error={error} />
          return <ProductPanel product={data.product} />;
        }}
      </Query>
    )
  }

  return (
    <PanelGroupController title="Product" expanded={props.expanded}>
      {elements}
    </PanelGroupController>
  );
}

function ProductPanel(props) {
  const { product } = props;
  
  const properties = fromJS([
    {prop: "sku", label: "SKU", type: "id"},
    {prop: "type", label: "Type", type: "string"},
    {prop: "title", label: "Title", type: "string"},
    {prop: "description", label: "Description", type: "text"},
    {prop: "weight", label: "Weight", type: "number", suffix: "g"},
    {prop: "width", label: "Width", type: "number", suffix: "mm"},
    {prop: "height", label: "Height", type: "number", suffix: "mm"},
    {prop: "depth", label: "Depth", type: "number", suffix: "mm"},
    {prop: "nrBundled", label: "Bundled", type: "number"}
  ])
  return (
    <>
      <MaybeProductImage sku={product.sku} />
      <PropertiesList properties={properties} data={fromJS(product)} />
    </>
  );
}

function MaybeProductImage({sku}) {
  if (!sku) {
    return null;
  }

  return (
    <>
      <ProductImage sku={sku} />
      <div style={{
        borderTop: "1px solid var(--grey-200)",
        marginBottom: "var(--sg-spacing-small)",
        marginLeft: "calc(-1 * var(--panel-group-padding))",
        marginRight: "calc(-1 * var(--panel-group-padding))",
        }} />
    </>
  );
}

export default CustomerPropertiesPanel;